<template>
	<section v-if="items.length" class="content-section contentblocks">
		<div class="row">
			<div class="row row2">
				<slot name="blocks-header" />
				<div class="columns column12">
					<content-block
						v-for="item in items"
						:key="item.ID"
						:image="item.image"
						:image-webp="item.imageWebp ?? ''"
						:image-alt="item.imageAlt ?? ''"
						:header="item.header"
						:content="item.content"
						class="row contentblock"
					/>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	margin: auto;
	background: #fff;

	.row {
		background: var(--primary-background-color);

		.row2 {
			padding: 15px;
		}
	}

	.columns {
		background: var(--secondary-background-color);
		padding: 24px 24px 0;
	}
}
</style>
